<template>
	<input autocomplete="off" type="select-multiple"></input>
</template>

<script>
	export default {
		props: ['emails', 'value'],

		methods:{
	      	getInput: function(){
	      		var self = this;

	      		var REGEX_EMAIL = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@' +
                  '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';

	            $(self.$el).selectize({
	                persist: false,
	                maxItems: null,
	                valueField: 'email',
	                labelField: 'name',
	                searchField: ['name', 'email'],
	                options: this.emails,
	                render: {
	                    item: function(item, escape) {
	                        return '<div>' +
	                            (item.name ? '<span class="name selectize-name">' + escape(item.name) + '</span>' : '') +
	                            (item.email ? '<span class="selectize-email">' + escape(item.email) + '</span>' : '') +
	                        '</div>';
	                    },
	                    option: function(item, escape) {
	                        var label = item.name || item.email;
	                        var caption = item.name ? item.email : null;
	                        return '<div>' +
	                            '<span class="label">' + escape(label) + '</span>' +
	                            (caption ? '<span class="caption">' + escape(caption) + '</span>' : '') +
	                        '</div>';
	                    }
	                },
	                createFilter: function(input) {
	                    var match, regex;

	                    // email@address.com
	                    regex = new RegExp('^' + REGEX_EMAIL + '$', 'i');
	                    match = input.match(regex);
	                    if (match) return !this.options.hasOwnProperty(match[0]);

	                    // name <email@address.com>
	                    regex = new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i');
	                    match = input.match(regex);
	                    if (match) return !this.options.hasOwnProperty(match[2]);

	                    return false;
	                },
	                create: function(input) {
	                    if ((new RegExp('^' + REGEX_EMAIL + '$', 'i')).test(input)) {
	                        return {email: input};
	                    }
	                    var match = input.match(new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i'));
	                    if (match) {
	                        return {
	                            email : match[2],
	                            name  : $.trim(match[1])
	                        };
	                    }
	                    alert('Invalid email address.');
	                    return false;
	                }
	            });
	      	}


	    },

	    mounted: function() {
			var self = this;
	        $(self.$el)
	        	.val(this.value)
	        	.on('change', function() {
	            	self.$emit('input', this.value);
	        	});
	        this.getInput();
        },

        watch: {
            value: function(value) {
                $(this.$el).val(value);
            },

            emails: function(value){
            	this.getInput();
            }
        },

	    updated: function() {
	        this.getInput();
	    },

        destroyed(){
        	
        }
	}
</script>